// extracted by mini-css-extract-plugin
module.exports = {"screen":"styles-module--screen--2jeRC","small":"styles-module--small--2klCf","breadcrumbs":"styles-module--breadcrumbs--32IIa"};